export default __webpack_public_path__ + "../ckeditor/plugins/dialog/styles/dialog.css";